import angular from "angular";
import dcInstructorNav from "./instructor-nav.directive";
export default angular
  .module("instructor.directives.nav", [])
  .directive("dcInstructorNav", dcInstructorNav);
